import { render } from "./deleteAcces.vue?vue&type=template&id=8039358c&scoped=true"
import script from "./deleteAcces.vue?vue&type=script&lang=js"
export * from "./deleteAcces.vue?vue&type=script&lang=js"

import "./deleteAcces.vue?vue&type=style&index=0&id=8039358c&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8039358c"]])

export default __exports__